// extracted by mini-css-extract-plugin
export default {"timePart":"ScheduleRecord_timePart__Hkds+","linePart":"ScheduleRecord_linePart__GPZ2D","namePart":"ScheduleRecord_namePart__Kkqx0"};